function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { equalColorObjects } from '../utils/compare.js';
import { fire, tpl } from '../utils/dom.js';
import { Hue } from './hue.js';
import { Saturation } from './saturation.js';
import css from '../styles/color-picker.js';
import hueCss from '../styles/hue.js';
import saturationCss from '../styles/saturation.js';
var $isSame = Symbol('same');
var $color = Symbol('color');
var $hsva = Symbol('hsva');
var $update = Symbol('update');
var $parts = Symbol('parts');
export var $css = Symbol('css');
export var $sliders = Symbol('sliders');
export var ColorPicker = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ColorPicker, _HTMLElement);

  var _super = _createSuper(ColorPicker);

  function ColorPicker() {
    var _this;

    _classCallCheck(this, ColorPicker);

    _this = _super.call(this);
    var template = tpl("<style>".concat(_this[$css].join(''), "</style>"));

    var root = _this.attachShadow({
      mode: 'open'
    });

    root.appendChild(template.content.cloneNode(true));
    root.addEventListener('move', _assertThisInitialized(_this));
    _this[$parts] = _this[$sliders].map(function (slider) {
      return new slider(root);
    });
    return _this;
  }

  _createClass(ColorPicker, [{
    key: $css,
    get: function get() {
      return [css, hueCss, saturationCss];
    }
  }, {
    key: $sliders,
    get: function get() {
      return [Saturation, Hue];
    }
  }, {
    key: "color",
    get: function get() {
      return this[$color];
    }
  }, {
    key: "color",
    set: function set(newColor) {
      if (!this[$isSame](newColor)) {
        var newHsva = this.colorModel.toHsva(newColor);
        this[$update](newHsva);
        this[$color] = newColor;
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      // A user may set a property on an _instance_ of an element,
      // before its prototype has been connected to this class.
      // If so, we need to run it through the proper class setter.
      if (this.hasOwnProperty('color')) {
        var value = this.color;
        delete this['color'];
        this.color = value;
      } else if (!this.color) {
        this.color = this.colorModel.defaultColor;
      }
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(_attr, _oldVal, newVal) {
      var color = this.colorModel.fromAttr(newVal);

      if (!this[$isSame](color)) {
        this.color = color;
      }
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      // Merge the current HSV color object with updated params.
      var oldHsva = this[$hsva];

      var newHsva = _objectSpread(_objectSpread({}, oldHsva), event.detail);

      this[$update](newHsva);
      var newColor;

      if (!equalColorObjects(newHsva, oldHsva) && !this[$isSame](newColor = this.colorModel.fromHsva(newHsva))) {
        this[$color] = newColor;
        fire(this, 'color-changed', {
          value: newColor
        });
      }
    }
  }, {
    key: $isSame,
    value: function value(color) {
      return this.color && this.colorModel.equal(color, this.color);
    }
  }, {
    key: $update,
    value: function value(hsva) {
      this[$hsva] = hsva;
      this[$parts].forEach(function (part) {
        return part.update(hsva);
      });
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['color'];
    }
  }]);

  return ColorPicker;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));